/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Ship } from './Ship';
import {
    ShipFromJSON,
    ShipFromJSONTyped,
    ShipToJSON,
} from './Ship';

/**
 * 
 * @export
 * @interface ShipInfoMmsiGet200Response
 */
export interface ShipInfoMmsiGet200Response {
    /**
     * 
     * @type {Ship}
     * @memberof ShipInfoMmsiGet200Response
     */
    ship?: Ship;
}

/**
 * Check if a given object implements the ShipInfoMmsiGet200Response interface.
 */
export function instanceOfShipInfoMmsiGet200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ShipInfoMmsiGet200ResponseFromJSON(json: any): ShipInfoMmsiGet200Response {
    return ShipInfoMmsiGet200ResponseFromJSONTyped(json, false);
}

export function ShipInfoMmsiGet200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShipInfoMmsiGet200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ship': !exists(json, 'ship') ? undefined : ShipFromJSON(json['ship']),
    };
}

export function ShipInfoMmsiGet200ResponseToJSON(value?: ShipInfoMmsiGet200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ship': ShipToJSON(value.ship),
    };
}

